@if (show) {
  <table style="width: 100%">
    <thead>
      <tr>
        <th>
          <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '40px', margin: '0' }" />
        </th>
      </tr>
    </thead>
    <tbody>
      @for (each of loaderItems(5); track each) {
        <tr>
          <td>
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '80px', margin: '0' }" />
          </td>
        </tr>
      }
    </tbody>
  </table>
}
